import { IconButton } from "ui/icon-button/icon-button";

import { type ActionsMenuTriggerProps } from "ui/actions-menu/actions-menu.types";

import Icons from "assets";

export const ActionsMenuTrigger = ({
  size = "medium",
  "aria-label": ariaLabel = "More actions",
  title = "More actions",
  ...rest
}: ActionsMenuTriggerProps) => (
  <IconButton aria-label={ariaLabel} title={title} variant="outlined" size={size} {...rest}>
    <Icons.More />
  </IconButton>
);
